export default __webpack_public_path__ + "static/app_screenshot_4-91c7a5a606691d31fc41e8269873b1e7.webp";